import { createSelector } from '@ngrx/store';
import { IRootState } from '../../../root';
import { ICardState } from './card.state';

export class CardSelectors {
  // todo: replace any type state with root state (once defined)
  static readonly cardState = (state: IRootState): ICardState => {
    return state.card as ICardState;
  };

  static readonly model = createSelector(CardSelectors.cardState, (card: ICardState) => {
    return card.model;
  });

  static readonly data = createSelector(CardSelectors.cardState, (card: ICardState) => {
    return card.data;
  });
}
